<app-card>
  <div header>
    <div class="d-flex step-title">
      <div class="justify-content-start mr-0">
        <p>{{'changePassword' | translate}}</p>
      </div>
    </div>
  </div>
    <div class="row justify-content-center">
      <div class="col-sm-6 col-xl-4 offset-xl-1">
        <div class="row section">
          <div class="d-flex align-items-center px-5">
            <button mat-raised-button color="primary" class="c-white"
                                                         (click)="redirectToChangePassword()">{{'goToChangePassword' | translate | uppercase}}</button>
          </div>
        </div>
      </div>
    </div>

</app-card>
